import type {
  Route,
  UrlMatchResult,
  UrlSegment,
  UrlSegmentGroup,
} from '@angular/router';
import { convertToParamMap } from '@angular/router';

export function masterArticleRouteMatcher(
  segments: readonly UrlSegment[],
  group: UrlSegmentGroup,
  route: Route,
): UrlMatchResult | null {
  if (/^what-is(-.+)?(\/.*)?$/.test(group.toString())) {
    const urlPaths = segments.map(urlSegment => urlSegment.path);
    return {
      consumed: segments.map(segment => segment),
      posParams: {
        seoUrl: {
          path: urlPaths.join('/').replace(/^what-is(-?)/, ''),
          parameters: {},
          parameterMap: convertToParamMap({}),
        },
      },
    };
  }
  return null;
}
